import { Form } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { financeLifeOpenWithdrawSelector } from "store/bailiff/finance/life/life.selector";
import { paymentWithdrawLastSelector } from "store/bailiff/payment/withdraw/payment_withdraw.selector";
//
//component
//redux
//selector
//actions
export const TriggerBanks = () => {
  // -------------------------- VAR ----------------------------
  const form = Form?.useFormInstance();
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const open = useSelector(financeLifeOpenWithdrawSelector);
  const last = useSelector(paymentWithdrawLastSelector);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (open && form && last) {
      const { accountName, accountNumber, code } = last;
      const saveBank = false;
      form?.setFieldsValue({
        accountName,
        accountNumber,
        code,
        saveBank,
      });
    }
  }, [open, form, last, dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerBanks;
